import { withTranslation } from 'react-i18next'
import Header from '../../components/layout/Header'

export default withTranslation()(Header)
